import { Deserializable } from './deserializable.model';
import { Insight } from './insight.model';
import { JsonObject } from './json-object.model';
import { Traits } from './traits.model';
import { Usage } from './usage.model';

export class ScreenDashboard implements Deserializable<any, ScreenDashboard> {
  error: any;
  insights: Insight[];

  constructor(dashboardData?: { error?: any; usage?: Usage[]; insights?: Insight[]; traits?: Traits[] }) {
    if (dashboardData) {
      this.error = dashboardData.error;
      this.insights = dashboardData.insights?.map((insightJson) => new Insight().deserialize(insightJson));
    }
  }

  deserialize(json: JsonObject, existingData?: ScreenDashboard): ScreenDashboard {
    if (json == null) {
      return null;
    }

    this.error = json['error'] || (existingData && existingData.error);

    this.insights = (json['insights'] || existingData?.insights)?.map((insightJson) =>
      new Insight().deserialize(insightJson)
    );

    return this;
  }
}
